import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
import { IMAGES } from '../../lib/constants';
const TESTIMONIALS = [{
  quote: 'Antes analizaba los casos siguiendo un orden diferente cada vez. Hoy tengo un proceso claro y eso me da mucha más seguridad al tomar decisiones.',
  name: 'Dra. Rocío M.',
  place: 'Colombia',
  image: IMAGES.t1
}, {
  quote: 'El tomo sobre el perfil cambió completamente mi forma de decidir entre extracción y expansión. Ahora entiendo el porqué de cada decisión.',
  name: 'Dr. Alejandro M.',
  place: 'México',
  image: IMAGES.t2
}, {
  quote: 'Solo el Checklist Maestro ya cambió mi rutina clínica. Hoy reviso cada caso siguiendo el mismo protocolo antes de presentar el tratamiento.',
  name: 'Dra. Valentina P.',
  place: 'Argentina',
  image: IMAGES.t3
}];
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-288" data-mp="1skj4id9mv1lh">
      <div className="mx-auto max-w-2xl" data-id="element-289" data-mp="1sm4108ficulz">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-290" data-mp="1nu2qos1whdyl">
          Lo que están diciendo otros ortodoncistas
        </h2>

        <ul className="mt-8 space-y-4" data-id="element-291" data-mp="1et4ma8njv4fh">
          {TESTIMONIALS.map((item, index) => <motion.li key={item.name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: Math.min(index * 0.05, 0.15)
        }} className="rounded-3xl border border-navy-100 bg-cream p-5 shadow-card" data-id="element-292" data-mp="1erbe2oxagc5d" data-mpi={index}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-293" data-mp="1xlqcacbs00s5">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-294" data-mp="m3xjgxh2bsof" data-mpi={starIndex} />)}
              </div>
              <blockquote className="mt-3 text-[14.5px] italic leading-relaxed text-navy-700 sm:text-base" data-id="element-295" data-mp="sje6ehnjxpmo">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-dashed border-navy-200 pt-4" data-id="element-296" data-mp="im03lkujwzcu">
                <img src={item.image} alt={`Retrato de ${item.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-297" data-mp="4uv3yir6o72i" />
                <span className="min-w-0" data-id="element-298" data-mp="3r462gdyjyn7h">
                  <span className="block truncate text-[14px] font-bold text-navy-900" data-id="element-299" data-mp="3w1666i7xjdvf">
                    {item.name}
                  </span>
                  <span className="block text-[12.5px] font-medium text-navy-500" data-id="element-300" data-mp="3i26knjfprf3h">
                    Ortodoncista · {item.place}
                  </span>
                </span>
              </figcaption>
            </motion.li>)}
        </ul>

        <TransformCta headline="Únete a los ortodoncistas que ya diagnostican con un protocolo." label="Quiero los mismos resultados" location="testimonios" data-id="element-301" data-mp="2yg4ok54sgghb" />
      </div>
    </section>;
}